import { TableCard } from 'app/components'
import { SncrBlocosHeader } from './components/SncrBlocosHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { SncrBlocosTable } from './table/SncrBlocosTable'

const SncrBlocosList = () => (
  <TableCard>
    <SncrBlocosHeader />
    <SncrBlocosTable />
  </TableCard>
)

export const SncrBlocosListPage = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <SncrBlocosList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
